import { render } from "./WalletItem.vue?vue&type=template&id=42637e4c&scoped=true"
import script from "./WalletItem.vue?vue&type=script&lang=js"
export * from "./WalletItem.vue?vue&type=script&lang=js"

import "./WalletItem.vue?vue&type=style&index=0&id=42637e4c&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42637e4c"]])

export default __exports__